@if (!loading()) {
  <div class="flex flex-col">
    <div class="w-full">
      <hm-eleks-visits-list [userId]="userId()"></hm-eleks-visits-list>
    </div>

    @if (selectedEleksVisit$ | async) {
      @if (!syncing() && !eleksVisitErrorMessage()) {
        <div
          [formGroup]="appointmentForm"
          class="flex w-full flex-col"
        >
          <mat-form-field
            appearance="outline"
            class="w-full"
          >
            <mat-label>Адреса клініки</mat-label>
            <input
              matInput
              type="text"
              formControlName="clinicAddress"
              [matAutocomplete]="clinicAddressAutocomplete"
              (input)="searchClinicAddress($any($event.target).value)"
              placeholder="Виберіть адресу клініки"
            />
            <mat-autocomplete
              #clinicAddressAutocomplete="matAutocomplete"
              (optionSelected)="selectClinicAddress($event.option.value)"
            >
              @for (address of clinicOptions; track $index) {
                <mat-option [value]="address">
                  {{ address.companyAddress }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (fc.clinicAddress.invalid && fc.clinicAddress.touched) {
              <mat-error>Це обов'язкове поле</mat-error>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="w-full"
          >
            <mat-label>ПІБ лікаря</mat-label>
            <input
              matInput
              type="text"
              formControlName="doctorName"
              [matAutocomplete]="doctorsAutocomplete"
              (input)="searchDoctor($any($event.target).value)"
              placeholder="Введіть ПІБ лікаря"
            />
            <mat-autocomplete
              #doctorsAutocomplete="matAutocomplete"
              (optionSelected)="selectDoctor($event.option.value.id, $event.option.value.fullName)"
            >
              @for (doctor of doctorsOptions; track $index) {
                <mat-option [value]="doctor">
                  {{ doctor.fullName }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (fc.doctorName.invalid && fc.doctorName.touched) {
              <mat-error>Це обов'язкове поле</mat-error>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="w-full"
          >
            <mat-label>Коментар</mat-label>
            <textarea
              matInput
              formControlName="comment"
              cdkTextareaAutosize
              placeholder="Додатковий коментар (необов'язково)"
              rows="3"
            ></textarea>
          </mat-form-field>
        </div>
      } @else if (eleksVisitErrorMessage()) {
        <div class="bg-red-50 border-red-200 flex w-full items-center gap-4 rounded-lg border p-4">
          <img
            priority="true"
            alt="Warning"
            width="24"
            height="24"
            [ngSrc]="'/assets/icons/ic_warning_fire.svg'"
          />
          <span class="text-red-800">{{ eleksVisitErrorMessage() }}</span>
        </div>
      } @else {
        <div class="flex h-[200px] w-full items-center justify-center">
          <shared-loader></shared-loader>
        </div>
      }
    }
  </div>
} @else {
  <div class="flex h-full w-full items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
